export const WEBSITE_ENDPOINT = `https://${process.env.NEXT_PUBLIC_WEBSITE_DOMAIN_NAME}`;
